<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>Meter Settings</h4>
            </v-flex>
            <v-flex xs6>
              <v-row align="center">
                <v-flex pr-2>
                  <v-checkbox
                    v-model="enableMeter"
                    label="Enable Meter"
                  ></v-checkbox>
                </v-flex>
                <v-btn @click="updateMeterSettings" small>Update</v-btn>
              </v-row>
              <h4>Metering</h4>
              <p>Metering changes the pricing of trips from 'up front' to a price derived from the 'fixed' mileage of the trip + a variable per 'minute' charge based on the duration of the trip.</p>
              <h4>Waiting Time</h4>
              <p>Waiting time charges a variable amount based on the time from driver arrival / picked time to passenger on board. You can set waiting time on Availability Region Tariffs, or on individual customers via their 'profile' page.
              <p></p>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "meter",
  components: {
    Overview,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      enableMeter: false,
    };
  },
  mounted: async function() {
    this.getMeterSettings();
  },
  methods: {
    getMeterSettings: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/meter/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.enableMeter = res.data.enableMeter;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateMeterSettings: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${
        this.$store.state.apiUrl
      }/meter/settings/enableMeter?enable=${this.enableMeter} `;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("Meter updated");
          } else {
            alert(
              "Meter failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
